import { useState } from 'react';
import { DosageDiaryList } from '../components/DosageDiaryList';
import { DosageDiaryUploader } from '../components/DosageDIaryUploader';
import { useAuth } from 'react-oidc-context';
import { PlusIcon } from '@heroicons/react/24/outline';

export default function DosageDiary() {
  const [isUploaderVisible, setUploaderVisibility] = useState(false);
  const { user } = useAuth();
  const [fetchDosageDiary, setFetchDosageDiary] = useState(false);

  return (
    <>
      <DosageDiaryList fetchDosageDiary={fetchDosageDiary} />
      <div className="fixed bottom-6 right-6 z-50">
        <button
          type="button"
          className="rounded-full bg-secondary-cornflowerblue-600 p-2 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline 
        focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={() => setUploaderVisibility(true)}
        >
          <PlusIcon aria-hidden="true" className="size-8" />
        </button>
        <DosageDiaryUploader
          isUploaderVisible={isUploaderVisible}
          setUploaderVisibility={(val) => setUploaderVisibility(val)}
          token={user!.access_token}
          fetchTrigger={() => setFetchDosageDiary((prev) => !prev)}
        />
      </div>
    </>
  );
}
